// PARTNERS WITH THEIR TRADES, TRADES WITH THEIR PARTNERS (owner, 2026-10-16:
// "anywhere in the platform, when you show partner show their trade below
// it and when you show a trade/discipline, show possible partners below it,
// in all dropdowns searchs").
//
// ONE INDEX, built from the project roster (GET /projects/:id/participants/
// roster - utils/pickerRoster: each partner's `trades` as Discipline KEYS and
// `tradeLabels` as their names). Every picker asks it the same two
// questions, so a partner reads the same trades everywhere and a trade lists
// the same partners everywhere:
//
//   tradesOf(companyId)          -> ["Electrical", "Power"]
//   partnersOf(keyOrName)        -> ["BES", "DP Electric, Inc"]
//
// A trade is matched by its key ("E") OR its name ("Electrical"), case
// folded: discipline fields across the platform hold either (issues and the
// schedule store keys, imports and minutes store words).
import { useEffect, useMemo, useState } from "react";
import { loadRoster } from "components/PeoplePicker/PeoplePicker";

const norm = (v) => String(v === null || v === undefined ? "" : v).trim().toLowerCase();

/** The index for a roster (the array GET .../participants/roster answers). */
export function partnerTradeIndex(roster) {
  const byCompany = new Map();   // companyId -> trade names
  const byTrade = new Map();     // normalised key or name -> partner names
  for (const g of roster || []) {
    if (!g || g.role === "owner") continue;
    const id = String(g.companyId || "");
    const keys = Array.isArray(g.trades) ? g.trades : [];
    const labels = Array.isArray(g.tradeLabels) && g.tradeLabels.length ? g.tradeLabels : keys;
    if (id) byCompany.set(id, labels.filter(Boolean));
    const name = g.companyName || "";
    if (!name) continue;
    [...keys, ...labels].forEach((t) => {
      const k = norm(t);
      if (!k) return;
      if (!byTrade.has(k)) byTrade.set(k, []);
      if (!byTrade.get(k).includes(name)) byTrade.get(k).push(name);
    });
  }
  return {
    tradesOf: (companyId) => byCompany.get(String(companyId || "")) || [],
    partnersOf: (...trade) => {
      const out = [];
      trade.flat().forEach((t) => (byTrade.get(norm(t)) || []).forEach((n) => { if (!out.includes(n)) out.push(n); }));
      return out;
    },
    empty: byCompany.size === 0,
  };
}

const EMPTY = partnerTradeIndex([]);

/** The index for a project, from the roster every picker already shares. */
export function usePartnerTrades(projectId) {
  const [roster, setRoster] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!projectId) { setRoster(null); return undefined; }
    loadRoster(projectId).then((r) => { if (alive) setRoster(r); });
    return () => { alive = false; };
  }, [projectId]);
  return useMemo(() => (roster ? partnerTradeIndex(roster) : EMPTY), [roster]);
}

/** Text form, for places that take a string (option labels' search text, titles). */
export const tradesText = (trades) => (trades && trades.length ? trades.join(", ") : "");
export const partnersText = (partners) => (partners && partners.length ? partners.join(", ") : "");
